import { FAST_API_URL } from "../index";
import { throwIfNotOk } from "./httpErrors";

/**
 * Пики русской дорожки папки, посчитанные сервером редактора.
 *
 * 4119e839, папка 21, 02.10.2026: «нет аудио дорожки на русском». Пики оригинала считал браузер —
 * разбирал весь mp3 папки (6,2 МБ / 389,6 с), и медленный ноутбук не успевал к сроку: дорожка
 * рисовалась плоской. Сервер считает те же пики один раз (и кэширует), браузеру остаётся
 * нарисовать готовое. Вид — тот же, что у utils/audioPeaks: [min, max, min, max, …].
 *
 * Отказы: 404 `{"detail": {"reason": "no_original_audio", …}}` — у папки нет mp3; старый сервер
 * без этой ручки отвечает просто 404 «Not Found». И то и другое — ошибка (throwIfNotOk), а не
 * данные: вызывающий тогда разбирает mp3 в браузере, как раньше.
 */
export interface OriginalPeaksAnswer {
    /** Ровно 2 × buckets чисел: [min, max, …]. */
    peaks: number[];
    buckets: number;
    duration_ms?: number;
    file?: string;
    version?: string;
    cached?: boolean;
}

export interface OriginalPeaksArgs {
    mediaId: string;
    folder: number;
    buckets: number;
    signal?: AbortSignal;
}

export const getOriginalPeaksApi = async ({
    mediaId,
    folder,
    buckets,
    signal,
}: OriginalPeaksArgs): Promise<OriginalPeaksAnswer> => {
    const query = new URLSearchParams({
        media: mediaId,
        folder_num: String(folder),
        buckets: String(buckets),
    });
    const response = await fetch(`${FAST_API_URL}/original_peaks?${query.toString()}`, { signal });
    await throwIfNotOk(response, "original peaks failed");
    return response.json();
};
